import { BankAccountModel } from 'api-hooks/bank-account';
import { ChequeGiroLiteModel } from 'api-hooks/cheque-giro';
import { CustomerModel } from 'api-hooks/customer';
import { EmployeeLiteModel } from 'api-hooks/employee';
import { PaymentMethodModel } from 'api-hooks/payment-method';
import { Expose, Type } from 'class-transformer';
import { TransactionalStatusEnum } from 'common/constants/enum';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

export class AccountReceiveableCustomerLiteModel extends CommonModel {
  status: string;

  @Expose({ name: 'invoice_number' })
  invoiceNumber: string;

  @Expose({ name: 'payment_status' })
  paymentStatus: string;

  @Expose({ name: 'ref_id' })
  refId: string;

  @Type(() => Number)
  total: number;

  @Expose({ name: 'billing_to' })
  billingTo: string;

  @Expose({ name: 'due_date' })
  @Type(() => Date)
  dueDate: Date | null;

  @Expose({ name: 'paid_amount' })
  @Type(() => Number)
  paidAmount: number;
}

export class TransactionableLiteModel {
  id: string;
  number: string;
  status: string;
  acl: string;

  @Expose({ name: 'billing_to' })
  billingTo: string;

  @Type(() => Number)
  total: number;

  @Expose({ name: 'due_date' })
  @Type(() => Date)
  dueDate: Date;

  @Expose({ name: 'ref_id' })
  refId: string;

  @Expose({ name: 'paid_amount' })
  @Type(() => Number)
  paidAmount: number;
}

export class PaymentItemLiteModel extends CommonModel {
  @Type(() => Number)
  amount: number;

  @Type(() => Number)
  discount: number;

  @Type(() => Number)
  fee: number;

  @Type(() => Number)
  tax: number;

  @Type(() => Number)
  total: number;

  @Type(() => TransactionableLiteModel)
  transactionable: TransactionableLiteModel;
}

export class ChequeNoteModel extends CommonModel {
  name: string;
  status: string;
  type: string;

  @Expose({ name: 'available_at' })
  @Type(() => Date)
  availableAt: Date;

  @Expose({ name: 'expired_at' })
  @Type(() => Date)
  expiredAt: Date;

  @Expose({ name: 'issued_at' })
  @Type(() => Date)
  issuedAt: Date;

  @Expose({ name: 'reference_number' })
  referenceNumber: string;

  @Expose({ name: 'bank_account' })
  @Type(() => BankAccountModel)
  bankAccount: BankAccountModel;

  @Expose({ name: 'cheque_giro' })
  @Type(() => ChequeGiroLiteModel)
  chequeGiro: ChequeGiroLiteModel;
}

export class PaymentableModel extends CommonModel {
  balance: string;
  code: string;
  name: string;

  @Expose({ name: 'account_number' })
  accountNumber: string;
}

export class PaymentLiteModel extends CommonModel {
  @Type(() => Number)
  amount: number;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Expose({ name: 'payment_method' })
  @Type(() => PaymentMethodModel)
  paymentMethod: PaymentMethodModel;

  @Expose({ name: 'payment_items' })
  @Type(() => PaymentItemLiteModel)
  paymentItems: PaymentItemLiteModel[];

  @Expose({ name: 'cheque_note' })
  @Type(() => ChequeNoteModel)
  chequeNote: ChequeNoteModel;

  @Type(() => PaymentableModel)
  paymentable: PaymentableModel | null;
}

export class AccountReceiveableLiteModel extends CommonModel {
  description: string;
  number: string;
  status: TransactionalStatusEnum;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Type(() => CustomerModel)
  customer: CustomerModel;

  @Type(() => PaymentLiteModel)
  payment: PaymentLiteModel;

  @Expose({ name: 'created_by' })
  @Type(() => EmployeeLiteModel)
  createdBy: EmployeeLiteModel;

  @Expose({ name: 'is_resolved' })
  isResolved: boolean;
}

export class AccountReceivableModel extends AccountReceiveableLiteModel {
  @Expose({ name: 'ref_id' })
  refId: string;

  @Expose({ name: 'is_resolved' })
  isResolved: boolean;
}

//query
export type getAccountReceivablesInput = {
  params: CommonParamInput;
};

export type getAccountReceivableInput = {
  id: string;
};

export type getAccountReceivableAgentInput = {
  id: string;
  params?: { payment_status?: string; receipt_in_use?: boolean };
  othersKeys?: string[];
};

//mutation
export type AccountReceivableMutationInput = {
  transactionAt: Date;
  customerId: string;
  description: string;
  needApproval: boolean;
  paymentMethodId: string;
  paymentableId: string;
  chequeNote: object;
  paymentItems: {
    amount: number;
    tax: number;
    discount: number;
    fee: number;
  }[];
};
export type AccountReceivableUpdateInput = {
  id: string;
  body: AccountReceivableMutationInput;
};
export type AccountReceivableVoidInput = {
  id: string;
};
